import { Box, Divider, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Link } from "react-router";

import { PageHero, PageSection, usePageTitle } from "../../components";

import { DELIVERY_TYPES } from "./consts/delivery-types";

export const AanleveringenOverview: FC = () => {
  usePageTitle(
    "BRO-aanleveringen: registreren, corrigeren en verwijderen",
    "Grondwatermonitoringsput, meetnet of grondwaterstand registreren, corrigeren, verschuiven, invoegen of verwijderen bij de BRO? Bekijk alle aanleveringstypen die BROSTAR ondersteunt."
  );

  return (
    <Box>
      <PageHero
        title="Aanleveringen"
        subtitle="Of u nu een grondwatermonitoringsput (GMW), meetnet (GMN) of grondwaterstand (GLD) wilt registreren, corrigeren, verschuiven, invoegen of verwijderen: ontdek hier welke aanleveringstypen BROSTAR ondersteunt en hoe deze technisch worden verwerkt."
      />

      <PageSection>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {DELIVERY_TYPES.map((deliveryType) => (
            <Box
              key={deliveryType.slug}
              border="1px solid"
              borderColor="gray.100"
              rounded="large"
              overflow="hidden"
              boxShadow="sm"
              display="flex"
              flexDir="column"
              bg="white"
            >
              <Box p={7} flex="1">
                <Text fontSize="xs" fontWeight="700" color="gray.400" mb={3}>
                  AANLEVERINGSTYPE
                </Text>
                <Heading as="h2" fontSize="lg" color="text" mb={3} lineHeight="short">
                  {deliveryType.title}
                </Heading>
                <Divider mb={4} />
                <Text fontWeight="400" fontSize="sm" color="gray.600" lineHeight="tall">
                  {deliveryType.excerpt}
                </Text>
              </Box>
              <Box px={7} pb={7}>
                <Link
                  to={`/public/aanleveringen/${deliveryType.slug}`}
                  style={{ textDecoration: "none" }}
                >
                  <Text
                    fontSize="sm"
                    fontWeight="700"
                    color="primary"
                    display="inline-flex"
                    alignItems="center"
                    gap={1}
                  >
                    Lees meer →
                  </Text>
                </Link>
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </PageSection>
    </Box>
  );
};
